import { createAction } from 'src/lib/createAction';
import { RedirectUrl } from 'src/state/pageContext/pageContextPayloads';

export const pageContextActions = {
  setPageUrl: createAction('page/setPageUrlPageContext')<RedirectUrl>(),
};
